
<div class="export-modal">
  <div class="modal-header">
    <span class="header-icon"><i class="material-icons" style="font-size: 18px">filter_list</i></span>
    <span class="header-title">{{ modalTitle }}</span>
    <button class="close-btn" (click)="closeModal()">✕</button>
  </div>

  <div class="modal-body">
    @if(!(exportService.loading$ |async) && !(pipelineService.loading$ |async)){
      <div class="row">
        <mat-form-field>
          <mat-label>Saved Presets</mat-label>
          <mat-select [formControl]="presetControl">
            <mat-option [value]="null">Pipeline Default</mat-option>
            @for(savedExport of savedExportFields; track $index){
              <mat-option [value]="savedExport">{{savedExport.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <mat-form-field >
              <input
                matInput
                type="text"
                class="preset-name-input"
                placeholder="Export Preset Name"
                [formControl]="presetNameControl"
                />
            </mat-form-field>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-6">
              <div class="row" style="margin: 5px;">
                <button class="btn btn-save" (click)="savePreset()" [disabled]="!presetControl.value">Save</button>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row" style="margin: 5px">
                <button class="btn btn-save-new" (click)="saveAsNewPreset()" [disabled]="!presetNameControl.value?.length">Save as New Preset</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="action-buttons">
        <button class="btn btn-reset" (click)="resetToDefault()">
          Reset To Default <mat-icon style="font-size: 16px; padding-top: 4px;">refresh</mat-icon>
        </button>
        <button class="btn btn-clear" (click)="clearAllColumns()">
          Clear All Columns <mat-icon style="font-size: 16px; padding-top: 4px;">delete</mat-icon>
        </button>
      </div>

      <div class="add-columns-section">
        <div class="add-columns-header" (click)="toggleAddColumns()">
          <span>Add Columns</span>
          <span class="toggle-icon">{{ addColumnsOpen ? '−' : '+' }}</span>
        </div>
        @if(addColumnsOpen){
          @if (addColumnsOpen) {
            <div class="add-columns-dropdown">
              <mat-form-field class="search-fields">
                <input matInput
                  type="text"
                  class="search-fields-input"
                  placeholder="Search fields..."
                  [formControl]="searchColumnControl"
                  />
              </mat-form-field>
              <div class="fields-list">
                <div class="field-group">
                  @for(field of filteredColumns; track $index){
                    <div
                      class="field-item"
                      [class.selected]="selectedAvailableColumns.has(field)"
                      (click)="!!field.excludedType || field.type !=='combined_columns' ? toggleColumnSelection(field):null"
                      [class.disabled]="!!field.excludedType || field.type ==='combined_columns'"
                      >
                      {{ field.name }}
                      @if(field.type){
                        @switch(field.type){
                          @case('combined_columns'){
                            @if(field.as_combined_columns_example){
                              <span class="info-icon" [matTooltip]="field.as_combined_columns_example">ℹ</span>
                            }
                          }
                          @case('as_columns'){
                            @if(field.as_columns_example){
                              <span class="info-icon" [matTooltip]="field.as_columns_example">ℹ</span>
                            }
                          }
                          @case('summary'){
                            @if(field.summary_example){
                              <span class="info-icon" [matTooltip]="field.summary_example">ℹ</span>
                            }
                          }
                          @case('list'){
                            @if(field.example){
                              <span class="info-icon" [matTooltip]="field.example">ℹ</span>
                            }
                          }
                        }
                      }
                    </div>
                    @if(field.children.length > 0 && field.type !== 'summary'){
                      @for(col of field.children; track $index){
                        <div
                          class="field-item child"
                          [class.selected]="selectedAvailableColumns.has(col)"
                          (click)="field.type !== 'as_columns' ? toggleColumnSelection(col):null"
                          [class.disabled]="field.type ==='as_columns'"
                          >
                          {{ col.name }}
                          @if(field.type === 'combined_columns' && col.as_combined_columns_example){
                            <span class="info-icon" [matTooltip]="col.as_combined_columns_example">ℹ</span>
                          }
                        </div>
                      }
                    }
                  }
                </div>
              </div>
              <div class="dropdown-actions">
                <button class="btn btn-cancel-selection" (click)="cancelSelection()">
                  Cancel Selection
                </button>
                <button class="btn btn-add-selected" (click)="addSelectedColumns()">
                  Add Selected
                </button>
              </div>
            </div>
          }
        }
      </div>
      @if(selectedFields.length > 0){
        <h3 class="columns-title">Columns</h3>
      }

      <div
        class="columns-list"
        cdkDropList
        (cdkDropListDropped)="onDrop($event)"
        >
        @for(field of selectedFields; track $index; let idx = $index){
          <div
            class="column-row"
            cdkDrag
            >
            <div class="column-label">
              @if(field.parent && field.parent.type === 'combined_columns') {
                {{field.parent.name}} - {{ field.name }}<span class="info-icon" [matTooltip]="field.as_combined_columns_example">ℹ</span>
                }@else if(field.type==='as_columns'){
                {{field.name}} <span class="info-icon" [matTooltip]="field.as_columns_example">ℹ</span>
                <span class="checkable-chlidren">
                  @for(child of field.children; track $index){
                    <input [checked]="field.selectedChildren[child.id]" [name]="field.name+child.name" type="checkbox" (change)="toggleChildSelection(idx, child)"/>
                    <label [for]="field.name+child.name">{{child.name}}</label>
                  }
                </span>
                }@else{
                {{ field.name }}
                @if(field.type){
                  @switch(field.type){
                    @case('combined_columns'){
                      <span class="info-icon" [matTooltip]="field.as_combined_columns_example">ℹ</span>
                    }
                    @case('as_columns'){
                      <span class="info-icon" [matTooltip]="field.as_columns_example">ℹ</span>
                    }
                    @case('summary'){
                      <span class="info-icon" [matTooltip]="field.summary_example">ℹ</span>
                    }
                  }
                }
              }
            </div>
            <div class="column-actions">
              <button class="icon-btn" (click)="moveColumnUp($index)" [disabled]="$index === 0">▲</button>
              <button class="icon-btn" (click)="moveColumnDown($index)" [disabled]="$index >= this.selectedFields.length - 1">▼</button>
              <button class="icon-btn delete-btn" (click)="removeColumn($index)"><mat-icon style="font-size: 18px; padding-top: 4px;">delete</mat-icon></button>
            </div>
          </div>
        }
      </div>

      <div class="export-section">
        <button class="btn btn-export" (click)="exportPipeline()">Export Pipeline</button>
      </div>
      }@else{
      <div class="loading-spinner">
        <mat-spinner></mat-spinner>
      </div>
    }
  </div>
</div>
